import { initializeApp } from "firebase/app";
import { getRemoteConfig } from "firebase/remote-config";
import { getAnalytics } from "firebase/analytics";

let firebaseConfig = {};

try {
  firebaseConfig = JSON.parse(process.env.REACT_APP_FIREBASE_CONFIG || '{}');
} catch (e) {
  console.error("Failed to parse REACT_APP_FIREBASE_CONFIG", e);
}

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

const remoteConfig = getRemoteConfig(app);

remoteConfig.settings = {
  minimumFetchIntervalMillis: 5000,
};

export { remoteConfig };
